import React from 'react';
import PropTypes from 'prop-types';

/**
 * Backdrop — the dimming layer behind a SlidePanel. Visual only.
 *
 * Reuses the DS `modal-backdrop fade in` class names for exact visual parity with
 * the host's other modals (see Host DS contract in CLAUDE.md). It stays mounted
 * and always rendered so its opacity can transition (fade) as the `in` class
 * toggles — toggling `display` (as an earlier version did) snaps it instead of
 * fading and makes the dim vanish instantly while the panel is still sliding out.
 *
 * It is `pointer-events: none` and handles no clicks: the click-to-close lives
 * on SlidePanel's dedicated dismiss scrim (a full-viewport sibling of the dialog
 * painted just above this backdrop), NOT on the backdrop or the dock container.
 * Dimming and dismissal are deliberately separate concerns.
 *
 * @param {Object} props
 * @param {boolean} [props.show] - Whether the backdrop is faded in.
 * @returns {React.ReactElement}
 */
const Backdrop = ({ show }) => (
	<div
		className={`modal-backdrop fade${show ? ' in' : ''}`}
		style={{ pointerEvents: 'none' }}
		aria-hidden="true"
		data-testid="ws-nav-drawer-backdrop"
	/>
);

Backdrop.propTypes = {
	show: PropTypes.bool
};

Backdrop.defaultProps = {
	show: true
};

export { Backdrop };
